import React from 'react';
import { connect } from 'react-redux';
import ExpenseForm from './ExpenseForm';
import { startEditExpense, startRemoveExpense } from '../actions/expenses';
import ConfirmRemoveExpenseModal from './ConfirmRemoveExpenseModal';
import { Link } from "react-router-dom"; 

export class EditExpensePage extends React.Component {
  state = {
    confirmRemoveExpenseModalVisible: false
  };

  onSubmit = (expense) => {
    this.props.startEditExpense(this.props.expense.id, expense);
    this.props.history.push('/');
  };

  onRemove = () => {
    this.props.startRemoveExpense({ id: this.props.expense.id });
    this.props.history.push('/');
  };

  showConfirmRemoveExpenseModal = (e) => {
    this.setState(() => ({ confirmRemoveExpenseModalVisible: true }))
  };

  hideConfirmRemoveExpenseModal = (e) => {
    this.setState(() => ({ confirmRemoveExpenseModalVisible: false}))
  };
  
  render() {
    return (
      <div>
        <div className="content-container expense_page_edit">
          <div className="page-header">
              <h1 className="page_name">Edit Expense</h1>
          </div>
        </div>
        <div className="content-container edit_expense">
           <ExpenseForm
            expense={this.props.expense}
            onSubmit={this.onSubmit}
          />
          <div className="expense_form_button_delete">
            <button className="button delete_expense" onClick={this.showConfirmRemoveExpenseModal}>Delete</button>
          </div>
          <div className="expense_form_button">
              <Link className="button return_home" to="/dashboard">Return Home</Link>
          </div>  
        </div> 
        <ConfirmRemoveExpenseModal 
          visible = { this.state.confirmRemoveExpenseModalVisible }
          deleteExpense = { this.onRemove }
          hideModal = { this.hideConfirmRemoveExpenseModal }
        /> 
      </div>
    );
  }
};

const mapStateToProps = (state, props) => ({
  expense: state.expenses.find((expense) => expense.id === props.match.params.id)
});

const mapDispatchToProps = (dispatch, props) => ({
  startEditExpense: (id, expense) => dispatch(startEditExpense(id, expense)),
  startRemoveExpense: (data) => dispatch(startRemoveExpense(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(EditExpensePage);


// WEBPACK FOOTER //
// ./src/components/EditExpensePage.js